"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerBuildProjectPayloadFactoryFromJS = exports.ExplorerBuildProjectPayloadFactory = void 0;
const immutable_1 = require("immutable");
const BuildProjectRequestDto_1 = require("./BuildProjectRequestDto");
exports.ExplorerBuildProjectPayloadFactory = (0, immutable_1.Record)({
    ide: null,
    windowId: null,
    buildData: (0, BuildProjectRequestDto_1.BuildProjectRequestDtoFactory)()
});
const ExplorerBuildProjectPayloadFactoryFromJS = function (data) {
    const _buildData = (0, BuildProjectRequestDto_1.BuildProjectRequestDtoFactoryFromJs)(data.buildData);
    return (0, exports.ExplorerBuildProjectPayloadFactory)({
        ide: data.ide,
        windowId: data.windowId,
        buildData: _buildData
    });
};
exports.ExplorerBuildProjectPayloadFactoryFromJS = ExplorerBuildProjectPayloadFactoryFromJS;
//# sourceMappingURL=ExplorerBuildProjectPayload.js.map